const HAS_AFRAME = typeof window !== "undefined" && !!window.AFRAME;

const startAnimationSessionAFrame = (model, options = {}) => {
  console.log("startAnimationSessionAFrame");
  const { timeoutMs = 10000, pollMs = 100 } = options;
  return new Promise(resolve => {
    const start = Date.now();
    const el = model.el;

    // Ensure any automatic loop component does not interfere with scripted control
    try {
      if (el?.hasAttribute && el.hasAttribute("loop-animation")) {
        el.removeAttribute("loop-animation");
      }
    } catch (e) {
      // ignore
    }

    function hasMixer() {
      return el?.components?.["animation-mixer"]?.mixer || null;
    }

    function hasClips() {
      const cmp = el?.components?.["animation-mixer"];
      if (Array.isArray(cmp?.animations) && cmp.animations.length > 0) return true;
      if (Array.isArray(el?.object3D?.animations) && el.object3D.animations.length > 0) return true;
      return false;
    }

    function isReady() {
      return !!hasMixer() && hasClips();
    }

    function cleanup() {
      el?.removeEventListener("componentinitialized", onInitialized);
      el?.removeEventListener("model-loaded", onModelLoaded);
    }

    function onInitialized(e) {
      if (e?.detail?.name !== "animation-mixer") return;
      if (isReady()) {
        cleanup();
        resolve(true);
      }
    }

    function onModelLoaded() {
      if (isReady()) {
        cleanup();
        resolve(true);
      }
    }

    const tick = () => {
      if (isReady()) {
        cleanup();
        resolve(true);
        return;
      }
      if (Date.now() - start >= timeoutMs) {
        cleanup();
        resolve(false);
        return;
      }
      setTimeout(tick, pollMs);
    };

    // Fast path
    if (isReady()) {
      resolve(true);
      return;
    }

    el?.addEventListener("model-loaded", onModelLoaded);
    el?.addEventListener("componentinitialized", onInitialized);
    tick();
  });
};

const startAnimationSessionEditor = (model, options = {}) => {
  return new Promise(resolve => {
    try {
      if (typeof model.stopAnimation === "function") {
        model.stopAnimation();
      }
    } catch (_) {}

    if (model.model && model.model.animations) {
      model.animations = model.model.animations;
    }

    resolve(true);
  });
};

const startAnimationSession = (model, options = {}) => {
  if (!model || !model.isScriptableObject || model.scriptableType !== "model") {
    console.log("startAnimationSession requires a valid model object", model.isScriptableObject, model.scriptableType);
    throw new Error("startAnimationSession requires a valid model object");
  }

  if (HAS_AFRAME) {
    return startAnimationSessionAFrame(model, options);
  } else {
    return startAnimationSessionEditor(model, options);
  }
};

export { startAnimationSession };
